import React from 'react';
import { ExternalLinkIcon, UserPlusIcon, UserCheckIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
interface ConnectionProps {
  connection: {
    id: number;
    name: string;
    role: string;
    location: string;
    avatar: string;
    matchPercentage: number;
    tags: string[];
    matchReason: string;
    connectionType: 'course' | 'connected' | 'both';
    isConnected: boolean;
  };
}
const ConnectionCard: React.FC<ConnectionProps> = ({
  connection
}) => {
  return <div className="bg-white rounded-xl border border-gray-200 overflow-hidden h-full flex flex-col" data-id="element-682">
      <div className="p-5" data-id="element-683">
        <div className="flex items-start mb-4" data-id="element-684">
          <div className="w-16 h-16 rounded-full overflow-hidden border-2 border-custom-green flex-shrink-0" data-id="element-685">
            <img src={connection.avatar} alt={connection.name} className="w-full h-full object-cover" data-id="element-686" />
          </div>
          <div className="ml-4" data-id="element-687">
            <h3 className="text-base font-semibold text-gray-800" data-id="element-688">
              {connection.name}
            </h3>
            <p className="text-sm text-gray-500" data-id="element-689">{connection.role}</p>
            <p className="text-sm text-gray-500" data-id="element-690">{connection.location}</p>
          </div>
          <div className="ml-auto flex flex-col items-center" data-id="element-691">
            <div className="w-12 h-12 rounded-full bg-gray-50 flex items-center justify-center" data-id="element-692">
              <div className="text-lg font-bold text-custom-green" data-id="element-693">
                {connection.matchPercentage}%
              </div>
            </div>
            <div className="text-xs text-gray-500 mt-1" data-id="element-694">match</div>
          </div>
        </div>
        <div className="flex flex-wrap gap-2 mb-4" data-id="element-695">
          {connection.tags.map((tag, index) => <span key={index} className="px-2 py-1 bg-gray-100 text-gray-700 rounded-full text-xs" data-id="element-696">
              {tag}
            </span>)}
        </div>
        <div className="p-3 bg-gray-50 rounded-lg mb-4 text-sm text-gray-600" data-id="element-697">
          {connection.matchReason}
        </div>
        <div className="flex gap-2 mt-auto" data-id="element-698">
          <Link to={`/public-profile/${connection.id}`} className="flex-1 flex items-center justify-center py-2 bg-custom-green text-white rounded-lg transition-colors hover:bg-custom-green/90 text-sm" data-id="element-699">
            <ExternalLinkIcon size={16} className="mr-2" data-id="element-700" />
            Profilo Pubblico
          </Link>
          {connection.isConnected ? <button className="p-2 bg-gray-100 text-gray-600 rounded-lg hover:bg-gray-200 transition-colors" data-id="element-701">
              <UserCheckIcon size={20} data-id="element-702" />
            </button> : <button className="p-2 bg-custom-green/10 text-custom-green rounded-lg hover:bg-custom-green/20 transition-colors" data-id="element-703">
              <UserPlusIcon size={20} data-id="element-704" />
            </button>}
        </div>
      </div>
    </div>;
};
export default ConnectionCard;